(function () {
  'use strict';

  angular.module('itxApp.cmsPage')
      .service('CmsHeaderService', CmsHeaderService);

  CmsHeaderService.$inject = [

  ];

  function CmsHeaderService() {     
      var _this = this;

      return {
        sendLoginCmsEvent: _sendLoginCmsEvent,
        sendLogoutCmsEvent: _sendLogoutCmsEvent,
        sendCartEvent: function () {},
        sendRenderChange: _sendRenderChange
      };
      
      function _sendLoginCmsEvent() {
          var loginEvent = new CustomEvent('login-sucess',
              {
                  bubbles: true,
                  composed: true
              }
          );
          document.dispatchEvent(loginEvent);
      }

      function _sendLogoutCmsEvent() {
        var logoutEvent = new CustomEvent('logout-sucess',
          {
              bubbles: true,
              composed: true
          }
        );
        document.dispatchEvent(logoutEvent);
      }

      function _sendRenderChange() {
        var renderChange = new CustomEvent('render-change',
          {
              bubbles: true,
              composed: true
          }
        );
        document.dispatchEvent(renderChange);
      }

  }

})();

